<template lang="html">
  <footer class="footer">
    <div class="container">
      <div class="content has-text-centered">
        This resume is written in VueJS and deployed via s3 + cloudfront.
        See <a href="https://github.com/bkeane/resume">github</a> for details.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'bottom'
}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue